<template>
<main>
  <section class="box" v-loading="loading">
    <header>
      <b>{{info.status_text}}</b>
      <div class="r">
        <el-button type="danger" v-show="info.is_paid === 0" @click="goPay" round>立即支付</el-button>
      </div>
    </header>
    <figure class="desc">
      <h3>{{info.tour_full_title}}</h3>
      <p><span>团号:</span><b>{{info.tour_sn}}</b></p>
      <p>成人<strong>{{ info.adult_num }}</strong>儿童<strong>{{info.child_num}}</strong> 共<strong>{{ info.child_num + info.adult_num }}</strong>人</p>
      <p><span>出发日期:</span><time>{{info.departure_date}}</time></p>
      <router-link :to="{name: 'tour_detail', params: {id: info.tour_id }}">查看产品详情&gt;&gt;</router-link>
    </figure>
    <div class="order">
      <h4>订单信息</h4>
      <p><span>订单总价</span><b class="price">{{info.total_amount-info.coupon_deduct_amount}}</b></p>
      <p v-if='info.coupon_deduct_amount>0'><span>优惠金额</span><b>{{info.coupon_deduct_amount}}</b></p>
      <p><span>订单号</span><b>{{info.order_sn}}</b></p>
      <p><span>下单时间</span><b>{{info.created_at}}</b></p>
    </div>
    <div class="hotel">
      <h4>联系人信息</h4>
      <p><span>联系人</span><b>{{ info.contact_name }}</b></p>
      <p><span>联系手机号</span><b>{{info.contact_mobile}}</b></p>
      <p><span>备注</span><b>{{info.remark || '--'}}</b></p>
    </div>
    <div class="hotel">
      <h4>出游人信息</h4>
      <el-table :data="info.tourists">
        <el-table-column prop="cn_name" label="名称" width="160"></el-table-column>
        <el-table-column prop="phone" label="手机号" width="240"></el-table-column>
        <el-table-column prop="id_number" label="身份证">
        </el-table-column>
      </el-table>
    </div>
    <div class="table">
      <h4>费用明细</h4>
      <el-table :data="info.priceInfo">
        <el-table-column prop="name" label="项目" width="160"></el-table-column>
        <el-table-column prop="price" label="单价"></el-table-column>
        <el-table-column prop="count" label="数量"></el-table-column>
        <el-table-column v-if='info.coupon_deduct_amount>0' prop="coupon" label="优惠金额"></el-table-column>
        <el-table-column label="金额">
          <template slot-scope="s">
            <b class="price">{{s.row.total}}</b>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <div class="table">
      <h4>退订服务</h4>
      <p class="hint" v-if="!confirm.canExit">不可退订</p>
      <el-table v-else border :data="confirm.CancellationPolicyList">
        <el-table-column prop="FromDate" label="日期" width="200">
        </el-table-column>
        <el-table-column label="取消及变更费用">
          <template slot-scope="s">
            <span class="price" :class="{green: s.row.Amount === 0}">{{ s.row.Amount > 0 ? s.row.Amount : '免费取消' }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div> -->
  </section>
</main>
</template>

<script>
import moment from 'moment';
import $tour from '@api/tour';
export default {
  data () {
    return {
      loading: true,
      info: {},
    }
  },
  created () {
    const { order_sn } = this.$route.query;
    if ( !order_sn ) {
      this.$router.push({ name: 'tour' });
      return;
    }
    this.getInfo(order_sn);
  },
  computed: {
  },
  filters: {
    format (val, desc = "MM月DD日") {
      return moment(val).format(desc);
    }
  },
  methods: {
    goPay () {
      const { order_sn } = this.info;
      this.$router.push({ name: 'tour_pay', query: { orderNo: order_sn } });
    },
    async getInfo (orders_sn) {
      this.loading = true;
      const info = await $tour.orderDetail(orders_sn);
      this.info = { ...info, priceInfo: [{
        price: info.adult_price,
        name: '成人',
        count: info.adult_num,
        coupon:info.coupon_deduct_amount,
        total: parseFloat((info.adult_price * info.adult_num).toFixed(2)-info.coupon_deduct_amount)
      }, {
        price: info.child_price,
        name: '儿童',
        count: info.child_num,
        coupon:info.coupon_deduct_amount,
        total: parseFloat((info.child_price * info.child_num).toFixed(2)-info.coupon_deduct_amount)
      }].filter(v => !!v.count) };
      this.loading = false;
    }
  }
}
</script>

<style scoped src="./detail.css"></style>